import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { ActivatedRoute } from '@angular/router';
import { BookingService } from '../service/booking.service';
import { UserService } from '../service/user.service';
import { FaviconService } from '../favicon.service';
import { LoginService } from '../security/login.service';
import { BrugesVndBooking } from '../bruges-vnd-booking';

@Component({
  selector: 'app-edit-booking-bruges',
  templateUrl: './edit-booking-bruges.component.html',
  styleUrls: ['./edit-booking-bruges.component.css']
})
export class EditBookingBrugesComponent implements OnInit {

  booking!: BrugesVndBooking;

  viewMode = 1;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    public bookingService: BookingService,
    public userService: UserService,
    private favicon: FaviconService,
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
   }

  ngOnInit() {
    let uuid = this.route.snapshot.paramMap.get("uuid")!;
    this.httpService.getBookingByUuid(uuid)
    .subscribe(booking => {
      this.booking = this.bookingService.bookingToBrugesVndBooking(booking);
      this.bookingService.booking = this.booking;
      this.bookingService.addBrugesInfo(this.booking).subscribe(() => {
        console.log("picture and vademecum added to booking");
      });
    },
    error => console.error(error)
    );
  }

  activateTab(mode: number){
    this.viewMode = mode;
  }
}
